const Key = {
    LEFT: "ArrowLeft",
    RIGHT: "ArrowRight",
    UP: "ArrowUp",
    DOWN: "ArrowDown",
    BACKSPACE: "Backspace",
    TAB: "Tab",
    ENTER: "Enter",
    SHIFT_LEFT: "Left Shift",
    SHIFT_RIGHT: "Right Shift",
    CONTROL_LEFT: "Left Control",
    CONTROL_RIGHT: "Right Control",
    ALT_LEFT: "Left Alt",
    ALT_RIGHT: "Right Alt",
    PAUSE_BREAK: "Pause",
    CAPS_LOCK: "CapsLock",
    ESCAPE: "Escape",
    SPACE: " ",
    PAGE_UP: "PageUp",
    PAGE_DOWN: "PageDown",
    END: "End",
    HOME: "Home",
    INSERT: "Insert",
    DELETE: "Delete",
    OS_LEFT: "Left OS",
    OS_RIGHT: "Right OS",
    CONTEXT_MENU: "ContextMenu",
    SCROLL_LOCK: "ScrollLock",
    NUM_LOCK: "NumLock",
    NUMPAD_DIVIDE: "Numpad /",
    NUMPAD_MULTIPLY: "Numpad *",
    NUMPAD_SUBTRACT: "Numpad -",
    NUMPAD_ADD: "Numpad +",
    NUMPAD_ENTER: "Numpad Enter",

    NUMPAD_PERIOD: "Numpad .",
    NUMPAD_0: "Numpad 0",
    NUMPAD_1: "Numpad 1",
    NUMPAD_2: "Numpad 2",
    NUMPAD_3: "Numpad 3",
    NUMPAD_4: "Numpad 4",
    NUMPAD_5: "Numpad 5",
    NUMPAD_6: "Numpad 6",
    NUMPAD_7: "Numpad 7",
    NUMPAD_8: "Numpad 8",
    NUMPAD_9: "Numpad 9",

    NUMPAD_DELETE: "Numpad Delete",
    NUMPAD_INSERT: "Numpad Insert",
    NUMPAD_END: "Numpad End",
    NUMPAD_ARROW_DOWN: "Numpad ArrowDown",
    NUMPAD_PAGE_DOWN: "Numpad PageDown",
    NUMPAD_ARROW_LEFT: "Numpad ArrowLeft",
    NUMPAD_CLEAR: "Numpad Clear",
    NUMPAD_ARROW_RIGHT: "Numpad ArrowRight",
    NUMPAD_HOME: "Numpad Home",
    NUMPAD_ARROW_UP: "Numpad ArrowUp",
    NUMPAD_PAGE_UP: "Numpad PageUp",
};

export default Key;